export default {
  setPositions(state, positions) {
    state.allPositions = positions
  },
}
